// src/helpers/api_helper.js
import axios from "axios";
import accessToken from "./jwt-token-access/accessToken";
import { toast } from "react-toastify";

// ============================
// BASE URL - Add /api/ prefix
// ============================
const API_URL = process.env.REACT_APP_API_URL || "http://localhost:8080/api/";

const axiosApi = axios.create({
  baseURL: API_URL,
});

export const updateToken = () => {
  try {
    const authUser = localStorage.getItem('authUser');
    if (authUser) {
      const parsedUser = JSON.parse(authUser);
      const organizationId = parsedUser?.organizationId || parsedUser?.organization?.id;
      const token = parsedUser?.token;

      if (organizationId) {
        axiosApi.defaults.headers.common["X-Organization-ID"] = organizationId;
      }
      if (token) {
        axiosApi.defaults.headers.common["Authorization"] = "Bearer " + token;
      }
    }
  } catch (error) {
    console.error("Error updating token:", error);
  }
};

// ============================
// RESPONSE INTERCEPTOR
// ============================
axiosApi.interceptors.response.use(
  (response) => response,
  (error) => {
    console.error("API Error:", error?.response?.data || error.message);
    return Promise.reject(error);
  }
);

updateToken();

// ============================
// GET REQUEST
// ============================
export async function get(url, config = {}) {
  return await axiosApi
    .get(url, { ...config })
    .then((response) => response?.data)
    .catch((error) => {
      console.error(`GET ${url} error:`, error);
      throw error;
    });
}

// ============================
// POST WITH FORM DATA
// ============================
export async function postWithFormData(url, data, config = {}) {
  return axiosApi
    .post(url, data, { ...config })
    .then((response) => response.data)
    .catch((error) => {
      console.error(`POST FormData ${url} error:`, error);
      toast.error(error?.response?.data?.message || "Something went wrong");
      throw error;
    });
}

// ============================
// POST REQUEST
// ============================
export async function post(url, data, config = {}) {
  console.log(`📤 POST ${url}:`, data);
  return axiosApi
    .post(url, data, { ...config })
    .then((response) => {
      console.log(`📥 POST ${url} response:`, response.data);
      return response.data;
    })
    .catch((error) => {
      console.error(`❌ POST ${url} error:`, error);
      console.error("Error details:", error?.response?.data);
      toast.error(error?.response?.data?.message || "Something went wrong");
      throw error;
    });
}

// ============================
// PUT WITH FORM DATA
// ============================
export async function putWithFormData(url, data, config = {}) {
  return axiosApi
    .put(url, data, { ...config })
    .then((response) => response.data)
    .catch((error) => {
      console.error(`PUT FormData ${url} error:`, error);
      toast.error(error?.response?.data?.message || "Something went wrong");
      throw error;
    });
}

// ============================
// PUT REQUEST
// ============================
export async function put(url, data, config = {}) {
  console.log(`📤 PUT ${url}:`, data);
  return axiosApi
    .put(url, { ...data }, { ...config })
    .then((response) => {
      console.log(`📥 PUT ${url} response:`, response.data);
      return response.data;
    })
    .catch((error) => {
      console.error(`❌ PUT ${url} error:`, error);
      toast.error(error?.response?.data?.message || "Something went wrong");
      throw error;
    });
}

// ============================
// DELETE REQUEST
// ============================
export async function del(url, config = {}) {
  console.log(`📤 DELETE ${url}`);
  return await axiosApi
    .delete(url, { ...config })
    .then((response) => {
      console.log(`📥 DELETE ${url} response:`, response.data);
      return response.data;
    })
    .catch((error) => {
      console.error(`❌ DELETE ${url} error:`, error);
      toast.error(error?.response?.data?.message || "Something went wrong");
      throw error;
    });
}

// ============================
// EXPORT AXIOS INSTANCE FOR DIRECT USE
// ============================
export { axiosApi };









// import axios from "axios";
// import accessToken from "./jwt-token-access/accessToken";
// import { toast } from "react-toastify";

// // Base URL for axios
// const API_URL = "";

// const axiosApi = axios.create({
//   baseURL: API_URL,
// });

// export const updateToken = () => {
//   const authUser = localStorage.getItem('authUser');
//   if (authUser) {
//     const organizationId = JSON.parse(authUser)?.organizationId;
//     const token = JSON.parse(authUser)?.token;

//     axiosApi.defaults.headers.common["X-Organization-ID"] = organizationId;
//     if (token) {
//       axiosApi.defaults.headers.common["Authorization"] = "Bearer " + token;
//     }
//   }
// }

// axiosApi.interceptors.response.use(
//   (response) => response,
//   (error) => Promise.reject(error)
// );

// updateToken();

// export async function get(url, config = {}) {
//   return await axiosApi
//     .get(url, { ...config })
//     .then((response) => response?.data);
// }

// export async function postWithFormData(url, data, config = {}) {
//   return axiosApi
//     .post(url, data, { ...config })
//     .then((response) => response.data).catch((error) => {
//       toast.error(error?.response?.data.message || "Something went wrong")
//     });
// }

// export async function post(url, data, config = {}) {
//   return axiosApi
//     .post(url, data, { ...config })
//     .then((response) => response.data).catch((error) => {
//       console.log(error);
//       toast.error(error?.response?.data.message || "Something went wrong")
//     });
// }

// export async function putWithFormData(url, data, config = {}) {
//   return axiosApi
//     .put(url, data, { ...config })
//     .then((response) => response.data).catch((error) => {
//       toast.error(error?.response?.data.message || "Something went wrong")
//     });
// }

// export async function put(url, data, config = {}) {
//   return axiosApi
//     .put(url, { ...data }, { ...config })
//     .then((response) => response.data).catch((error) => {
//       toast.error(error?.response?.data.message || "Something went wrong")
//     });
// }

// export async function del(url, config = {}) {
//   console.log("from the del --->", url)
//   return await axiosApi
//     .delete(url, { ...config })
//     .then((response) => response.data).catch((error) => {
//       toast.error(error?.response?.data.message)
//     });
// }